 const reviewData = [
    {
        name:"Deepak Kumar",
        description:"जबसे मैंने AYURA MOUTHCARE KIT का इस्तेमाल किया है, मेरा मुंह पहले से बेहतर खुल रहा है।"
    },
    {
        name:"Mukesh Chand",
        description:"AYURA MOUTHCARE KIT, मेरा मुंह पहले की तरह करने के लिए आपका बहुत धन्यवाद।"
    },
    {
        name:"Sunny Thakur",
        description:"पहले मेरी एक उंगली मेरे मुंह में जाती थी, लेकिन अब चार उंगलियाँ चली जाती हैं। धन्यवाद आयुरा माउथकेयर किट।"
    },
];

export default reviewData;
